import React from "react";
import { RouteProps } from "react-router";
import Content from "Types/Content";
import ProfilePicture from "ProfilePictures/JustoMedina.jpeg";
import css3Picture from "Developers/JustoMedina/imgs/css3.png";
import html5Picture from "Developers/JustoMedina/imgs/html5.png";
import javascriptPicture from "Developers/JustoMedina/imgs/javascript.png";
import rnPicture from "Developers/JustoMedina/imgs/reactn.png";
import ProfileStyle from "Developers/JustoMedina/justomedina.module.scss";

const JustoMedina: React.FC<RouteProps> = () => {
  return (
    <div className='container'>
      <div className={`${ProfileStyle.contenido}`}>
        <div className={`${ProfileStyle.general}`}>
          <img
            className='rounded m-4'
            width={245}
            test-
            alt='Foto de perfil de Justo Medina'
            height={245}
            src={ProfilePicture}
          />
        </div>
        <div className={`${ProfileStyle.general}`}>
          <h2>Justo Alejandro Medina</h2>
        </div>
        <div>
          <h5>Team: Desarrollo de aplicaciones móviles</h5>
        </div>
        <div className={`${ProfileStyle.sobreMi}`}>
          <p>
            <h4>Sobre mi:</h4>
            Seguramente este perfil se vea un poco parecido al de mis compañeros
            pero es solo una ilusión óptica.
            <br />
            Soy de Tostado, Santa Fe (350km al norte de la provincia).
            <br />
            Actualmente vivo en Santa Fe Capital donde me encuentro estudiando
            Ingenieria en Sistemas de Informacion en la UTN-FRSF.
          </p>
        </div>
        <div className={`${ProfileStyle.general}`}>
          <div className={`${ProfileStyle.conocimientos}`}>
            <h4>Conocimientos generales:</h4>
          </div>
        </div>
        <div className={`${ProfileStyle.general}`}>
          <img
            className={`${ProfileStyle.logo}`}
            width={71}
            alt='Foto de js'
            height={71}
            src={javascriptPicture}
          />
          <img
            className={`${ProfileStyle.logo}`}
            width={71}
            alt='Foto de html5'
            height={71}
            src={html5Picture}
          />
          <img
            className={`${ProfileStyle.logo}`}
            width={71}
            alt='Foto de css3'
            height={71}
            src={css3Picture}
          />
          <img
            className={`${ProfileStyle.logo}`}
            width={71}
            alt='Foto de rn'
            height={71}
            src={rnPicture}
          />
        </div>
      </div>
    </div>
  );
};

export default new Content({
  Component: JustoMedina,
  title: "Justo Medina",
  route: "justo-medina",
  tags: ["trainee", "react-native", "js"]
});
